import MediaQueries from '../Grid/MediaQueries';

const fontWeights = {
  light: 300,
  regular: 400,
  medium: 500,
};

const typography = {
  effra119: {
    fontSize: '58px',
    fontWeight: fontWeights.regular,
    lineHeight: '0.96',
    letterSpacing: '-1px',
    [MediaQueries.md]: {
      fontSize: '100px',
      lineHeight: '0.92',
      letterSpacing: '-0.3px',
    },
    [MediaQueries.lgAndUp]: {
      fontSize: '119px',
      lineHeight: '0.92',
    },
  },
  effra100: {
    fontSize: '58px',
    fontWeight: fontWeights.regular,
    lineHeight: '0.96',
    letterSpacing: '-1px',
    [MediaQueries.mdAndUp]: {
      fontSize: '100px',
      lineHeight: '0.87',
      letterSpacing: '-0.3px',
    },
  },
  effra69: {
    fontSize: '58px',
    fontWeight: fontWeights.regular,
    lineHeight: '1',
    letterSpacing: '-1px',
    [MediaQueries.mdAndUp]: {
      fontSize: '69px',
      lineHeight: '0.99',
      letterSpacing: '-0.3px',
    },
  },
  effra58: {
    fontSize: '58px',
    fontWeight: fontWeights.regular,
    lineHeight: '1',
    letterSpacing: '-1px',
  },
  effra58Modal: {
    fontSize: '34px',
    fontWeight: fontWeights.medium,
    lineHeight: '1.17',
    [MediaQueries.mdAndUp]: {
      fontSize: '58px',
      fontWeight: fontWeights.medium,
      lineHeight: '1',
      letterSpacing: '-1px',
    },
  },
  effra58Input: {
    fontSize: '34px',
    fontWeight: fontWeights.light,
    lineHeight: '40px',
    letterSpacing: '-0.3px',
    [MediaQueries.mdAndUp]: {
      fontSize: '40px',
      lineHeight: '48px',
    },
    [MediaQueries.xl]: {
      fontSize: '58px',
      lineHeight: '1',
      letterSpacing: '-1px',
    },
  },
  effra48: {
    fontSize: '40px',
    fontWeight: fontWeights.regular,
    lineHeight: '1.20',
    letterSpacing: '-0.3px',
    [MediaQueries.mdAndUp]: {
      fontSize: '48px',
      lineHeight: '1.17',
      letterSpacing: '-1px',
    },
  },
  effra40: {
    fontSize: '40px',
    fontWeight: fontWeights.regular,
    lineHeight: '1.20',
    letterSpacing: '-0.3px',
  },
  effra34: {
    fontSize: '28px',
    fontWeight: fontWeights.regular,
    lineHeight: '1.43',
    letterSpacing: '-0.4px',
    [MediaQueries.mdAndUp]: {
      fontSize: '34px',
      letterSpacing: 0,
      lineHeight: '1.18',
    },
  },
  effra28: {
    fontSize: '28px',
    fontWeight: fontWeights.regular,
    lineHeight: '1.43',
    letterSpacing: '-0.4px',
  },
  effra28Footer: {
    fontSize: '22px',
    fontWeight: fontWeights.medium,
    lineHeight: '1.43',
    letterSpacing: '-0.4px',
    [MediaQueries.mdAndUp]: {
      fontSize: '28px',
    },
    [MediaQueries.lgAndUp]: {
      fontSize: '34px',
    },
  },
  effra22: {
    fontSize: '22px',
    fontWeight: fontWeights.regular,
    lineHeight: '1.45',
    letterSpacing: '-0.4px',
  },
  effra22Listing: {
    fontSize: '18px',
    fontWeight: fontWeights.regular,
    lineHeight: '1.67',
    [MediaQueries.lgAndUp]: {
      fontSize: '22px',
      fontWeight: fontWeights.regular,
      letterSpacing: '-0.0875px',
      lineHeight: '1.45',
    },
  },
  effra18: {
    fontSize: '18px',
    fontWeight: fontWeights.regular,
    lineHeight: '1.78',
  },
  effra16: {
    fontSize: '16px',
    fontWeight: fontWeights.regular,
    lineHeight: '1.5',
  },
  effra14: {
    fontSize: '14px',
    lineHeight: '1.71',
  },
  effra14Link: {
    fontSize: '14px',
    fontWeight: fontWeights.regular,
    lineHeight: '1.14',
    letterSpacing: '0.87px',
    textTransform: 'uppercase',
  },
  effra12: {
    fontSize: '12px',
    fontWeight: fontWeights.regular,
    lineHeight: '1.17',
  },
  effra12Link: {
    fontSize: '12px',
    fontWeight: fontWeights.regular,
    lineHeight: '1.33',
    letterSpacing: '0.8px',
    textTransform: 'uppercase',
  },
};

export { fontWeights, typography };
